import { render, staticRenderFns } from "./BowFiltersToggle.vue?vue&type=template&id=79c6faa5&"
import script from "./BowFiltersToggle.vue?vue&type=script&lang=js&"
export * from "./BowFiltersToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports